import React from 'react';

import PropTypes from 'prop-types';

import { cn } from '@/lib/utils';
import { SWATCH_COLORS } from './colors';

const TagSwatch = ({ color }) => {
  const swatchStyles = cn(
    'block h-3 w-3 shrink-0 rounded-full border border-white',
    SWATCH_COLORS[color]
  );

  return <span className={swatchStyles} />;
};

TagSwatch.propTypes = {
  color: PropTypes.string.isRequired,
};

export default TagSwatch;
